
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormPhotoUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { GENDERS } from '../../../shared/constants';

export const TraininggroupNewForm = ({ initData, onDataChanged, userData}) => {
  const [newTraininggroupData, setNewTraininggroupData] = useState({ ...initData });

  useEffect(() => {
 
    setNewTraininggroupData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newTraininggroupData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewTraininggroupData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
    
      <GroupItem>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
        <FormItem>
          <FormTextbox
            label='Name'
            value={newTraininggroupData.groupname}
            isEditing={false}
            onValueChange={updateField('groupname')}
          />
        </FormItem>
       
        <FormItem>
          <FormSelectBox
        
            label='Trainer'
            width='100%'
            value={newTraininggroupData.userId}
            dataSource={userData}
            displayExpr='displayName'
            valueExpr='userId'
            showClearButton={true}
            onValueChange={updateField('userId')}
          />
        </FormItem>
     
      </GroupItem>


    </Form>
  );
};
